document.addEventListener("DOMContentLoaded", () => {
  const shareBtn = document.getElementById("shareBtn"),
    shareMenu = document.getElementById("shareMenu"),
    shareIcon = document.getElementById("shareIcon"),
    closeIcon = document.getElementById("closeIcon"),
    copyLinkBtn = document.getElementById("copyLink"),
    currentUrl = window.location.href,
    copyNotification = document.getElementById("copyNotification"),
    shareIcons = document.querySelector(".share-icons"),
    shareBtnClass = document.querySelector(".share-menu .share-btn");

  document.getElementById("currentUrl").textContent = currentUrl;

  shareBtn.addEventListener("click", () => {
    shareMenu.classList.toggle("active");
    shareBtnClass?.classList.toggle("show-close-btn");

    if (shareIcon && closeIcon) {
      shareIcon.style.display = shareMenu.classList.contains("active") ? "none" : "block";
      closeIcon.style.display = shareMenu.classList.contains("active") ? "block" : "none";
    }
  });

  document.querySelectorAll(".share-menu .share-btn").forEach(btn =>
    btn.addEventListener("click", () => {
      shareMenu.classList.remove("active");
      shareBtnClass?.classList.remove("show-close-btn");
    })
  );

  copyLinkBtn.addEventListener("click", () => {
    navigator.clipboard.writeText(currentUrl).then(() => {
      copyNotification.style.display = "block";
      setTimeout(() => (copyNotification.style.display = "none"), 1000);
      shareMenu.classList.toggle("active");
      shareBtnClass?.classList.toggle("active");

      if (shareIcons && shareBtnClass) {
        shareIcons.style.display = shareMenu.classList.contains("active") ? "block" : "none";
        shareBtnClass.style.display = shareMenu.classList.contains("active") ? "none" : "block";
      }
    }).catch(err => console.error("Failed to copy: ", err));
  });

  const shareLinks = {
    shareTwitter: `https://twitter.com/intent/tweet?url=${encodeURIComponent(currentUrl)}`,
    shareFacebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`,
    shareWhatsapp: `https://api.whatsapp.com/send?text=${encodeURIComponent(currentUrl)}`,
    shareLinkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(currentUrl)}`
  };

  Object.keys(shareLinks).forEach(id => 
    document.getElementById(id)?.addEventListener("click", () => window.open(shareLinks[id], "_blank"))
  );
});
